var _circle, _path, _path2, _mask, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#CDEAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 24.3421C22.6097 24.3421 23.0104 24.7514 23.0104 25.2564V27.9992C23.0104 29.0091 23.8118 29.8278 24.8004 29.8278C25.789 29.8278 26.5904 29.0091 26.5904 27.9992V25.2564C26.5904 24.7514 26.9911 24.3421 27.4854 24.3421C27.9797 24.3421 28.3804 24.7514 28.3804 25.2564V27.9992C28.3804 30.019 26.7776 31.6564 24.8004 31.6564C22.8233 31.6564 21.2205 30.019 21.2205 27.9992V25.2564C21.2205 24.7514 21.6212 24.3421 22.1154 24.3421Z",
    fill: "#18223D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7025 22.348C15.7863 21.4061 16.5593 20.6849 17.4851 20.6849H21.2204V18.8564C21.2204 16.8366 22.8232 15.1992 24.8004 15.1992C26.7775 15.1992 28.3803 16.8366 28.3803 18.8564V20.6849H32.1157C33.0415 20.6849 33.8145 21.4061 33.8983 22.348L35.1854 36.811C35.376 38.9527 33.7253 40.7992 31.6201 40.7992H17.9807C15.8755 40.7992 14.2248 38.9527 14.4154 36.811L15.7025 22.348ZM24.8004 17.0278C23.8118 17.0278 23.0104 17.8465 23.0104 18.8564V20.6849H26.5903V18.8564C26.5903 17.8465 25.7889 17.0278 24.8004 17.0278ZM33.4028 36.9765L32.1157 22.5135L17.4851 22.5135L16.198 36.9765C16.1027 38.0474 16.9281 38.9706 17.9807 38.9706H31.6201C32.6727 38.9706 33.4981 38.0474 33.4028 36.9765Z",
    fill: "#18223D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2047_2466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.4004,
    y: 26.3984,
    width: 19.2,
    height: 9.6,
    rx: 2.09302
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.4004,
    y: 26.3984,
    width: 19.2,
    height: 9.6,
    rx: 2.09302,
    fill: "#E3F2FD",
    stroke: "#18223D",
    strokeWidth: 5.02326,
    mask: "url(#path-3-inside-1_2047_2466)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9961 29.3516V32.1534",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3867 30.8145L25.4728 30.8145",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0176 29.793L25.9571 31.7742",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0176 31.7734L25.9571 29.7923",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9375 29.3516V32.1534",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 30.8145L30.4142 30.8145",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3965 32.0293L35.4826 32.0293",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9629 29.793L30.9025 31.7742",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9629 31.7734L30.9025 29.7923",
    stroke: "#18223D",
    strokeWidth: 0.837209,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCode);
export default __webpack_public_path__ + "static/media/paymentCode.b4faea739c5df0aec581a4c2a420c12f.svg";
export { ForwardRef as ReactComponent };